import {LOCALE_ID, Inject, Injectable} from '@angular/core';
import {CalendarEventTitleFormatter, CalendarEvent} from 'angular-calendar';
import {format} from 'date-fns';

@Injectable()
export class CustomEventTitleFormatter extends CalendarEventTitleFormatter {
  private defaultImg = './assets/main/male-profile-icon.svg';

  constructor(@Inject(LOCALE_ID) private locale: string) {
    super();
  }

  // you can override any of the methods defined in the parent class

  month(event: CalendarEvent): string {
    const {patientName, patientImg} = event.meta;

    return `<p>
                <img src="${patientImg ? patientImg : this.defaultImg}" alt="Performer image">
                <span>${patientName}</span>
                <span>${event.title}</span>
                <span>${format(event.start, 'hh:mm a')}</span>
            </p>`;
  }

  week(event: CalendarEvent): string {
    const {patientName} = event.meta;

    return `<p>
                <span>${patientName}</span>
                <span>${event.title}</span>
            </p>`;
  }

  day(event: CalendarEvent): string {
    const {patientName, patientImg} = event.meta;

    return `<p>
                <img src="${patientImg ? patientImg : this.defaultImg}" alt="Performer image">
                <span>${patientName}</span>
                <span>${event.title}</span>
            </p>`;
  }
}
